(() => {
  const key = 'janicca-favorites-v1';
  const expiry = 90 * 24 * 60 * 60 * 1000;
  const openers = new WeakMap();
  let wishlistRevision = 0;
  const read = () => {
    try {
      const data = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(data) ? data.filter(item => item && typeof item.handle === 'string' && /^[a-z0-9][a-z0-9-]*$/.test(item.handle) && Date.now() - item.saved < expiry).slice(0, 60) : [];
    } catch { return []; }
  };
  const status = message => { const live = document.querySelector('[data-je-status]'); if (live) live.textContent = message; };
  const save = items => {
    try { localStorage.setItem(key, JSON.stringify(items)); return true; }
    catch { status(document.querySelector('#je-wishlist')?.dataset.storage || ''); return false; }
  };
  const sync = () => {
    const items = read();
    const dialog = document.querySelector('#je-wishlist');
    document.querySelectorAll('[data-je-wish]').forEach(button => {
      const active = items.some(item => item.handle === button.dataset.jeWish);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', (active ? dialog?.dataset.remove : dialog?.dataset.add) || button.getAttribute('aria-label'));
    });
    document.querySelectorAll('[data-je-wish-count]').forEach(count => { count.textContent = String(items.length); count.hidden = !items.length; });
  };
  const show = (dialog, opener) => {
    if (!dialog || dialog.open) return;
    openers.set(dialog, opener);
    dialog.showModal();
    dialog.querySelector('[data-je-close]')?.focus();
    if (dialog.id === 'je-wishlist') renderWishlist();
  };
  const renderWishlist = async () => {
    const revision = ++wishlistRevision;
    const dialog = document.querySelector('#je-wishlist');
    const container = dialog?.querySelector('[data-je-wishlist-items]');
    if (!container) return;
    const items = read();
    container.classList.toggle('je-wishlist-items', !!items.length);
    container.textContent = items.length ? dialog.dataset.loading : dialog.dataset.empty;
    if (!items.length) return;
    const root = dialog.dataset.root || '/';
    const results = await Promise.all(items.map(async item => {
      try {
        const response = await fetch(root.replace(/\/?$/, '/') + 'products/' + encodeURIComponent(item.handle) + '.js', { credentials: 'same-origin' });
        if (!response.ok) return { item, unavailable: response.status === 404 };
        return { item, product: await response.json() };
      } catch { return { item, error: true }; }
    }));
    if (revision !== wishlistRevision || !container.isConnected) return;
    container.replaceChildren();
    results.forEach(({ item, product, unavailable }) => {
      const article = document.createElement('article');
      article.className = 'je-wishlist-item';
      if (product) {
        const link = document.createElement('a');
        link.href = root.replace(/\/?$/, '/') + 'products/' + encodeURIComponent(item.handle);
        if (product.featured_image) {
          const image = document.createElement('img');
          const url = new URL(product.featured_image, location.origin);
          if (url.protocol === 'https:') { url.searchParams.set('width', '500'); image.src = url.href; }
          image.alt = product.title;
          image.loading = 'lazy';
          image.width = 500;
          image.height = 667;
          link.append(image);
        }
        const title = document.createElement('p');
        title.textContent = product.title;
        link.append(title);
        article.append(link);
        const price = document.createElement('p');
        price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'es', { style: 'currency', currency: dialog.dataset.currency || 'EUR' }).format(product.price / 100);
        article.append(price);
      } else {
        const message = document.createElement('p');
        message.textContent = unavailable ? dialog.dataset.unavailable : dialog.dataset.error;
        article.append(message);
      }
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.dataset.jeRemove = item.handle;
      remove.setAttribute('aria-label', dialog.dataset.remove + (product ? ': ' + product.title : ''));
      remove.textContent = '×';
      article.append(remove);
      container.append(article);
    });
  };
  const carouselState = element => {
    const track = element.querySelector('[data-je-track]');
    if (!track) return;
    const previous = element.querySelector('[data-je-prev]');
    const next = element.querySelector('[data-je-next]');
    if (previous) previous.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
  };
  const initialize = (scope = document) => {
    scope.querySelectorAll('.je-dialog').forEach(dialog => {
      if (dialog.dataset.jeReady) return;
      dialog.dataset.jeReady = 'true';
      dialog.addEventListener('close', () => openers.get(dialog)?.focus());
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
    });
    scope.querySelectorAll('[data-je-carousel]').forEach(element => {
      if (!element.dataset.jeReady) {
        element.dataset.jeReady = 'true';
        element.querySelector('[data-je-track]')?.addEventListener('scroll', () => carouselState(element), { passive: true });
        new ResizeObserver(() => carouselState(element)).observe(element);
      }
      carouselState(element);
    });
    sync();
  };
  document.addEventListener('click', async event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const trigger = target.closest('[data-je-open]');
    if (trigger) { show(document.getElementById(trigger.dataset.jeOpen), trigger); return; }
    const close = target.closest('[data-je-close]');
    if (close) { close.closest('dialog')?.close(); return; }
    const wish = target.closest('[data-je-wish]');
    if (wish) {
      event.preventDefault();
      event.stopPropagation();
      const items = read();
      const handle = wish.dataset.jeWish;
      if (!/^[a-z0-9][a-z0-9-]*$/.test(handle)) return;
      const next = items.some(item => item.handle === handle) ? items.filter(item => item.handle !== handle) : [{ handle, saved: Date.now() }, ...items].slice(0, 60);
      if (save(next)) { sync(); if (document.querySelector('#je-wishlist')?.open) renderWishlist(); }
      return;
    }
    const remove = target.closest('[data-je-remove]');
    if (remove) { if (save(read().filter(item => item.handle !== remove.dataset.jeRemove))) { sync(); await renderWishlist(); document.querySelector('#je-wishlist [data-je-close]')?.focus(); } return; }
    const carouselButton = target.closest('[data-je-prev],[data-je-next]');
    if (carouselButton) {
      const track = carouselButton.closest('[data-je-carousel]').querySelector('[data-je-track]');
      track.scrollBy({ left: track.clientWidth * (carouselButton.hasAttribute('data-je-prev') ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      return;
    }
    const share = target.closest('[data-je-share]');
    if (share) {
      try {
        if (navigator.share) await navigator.share({ url: share.dataset.url });
        else { await navigator.clipboard.writeText(share.dataset.url); status(share.dataset.copied); }
      } catch (error) { if (error.name !== 'AbortError') status(share.dataset.error); }
      return;
    }
    if (target.closest('[data-je-cookies]')) {
      if (window.Shopify?.privacyBanner?.showPreferences) window.Shopify.privacyBanner.showPreferences();
      else if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) window.Shopify?.privacyBanner?.showPreferences?.(); });
    }
  });
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:block:select', event => {
    const dialog = event.target.closest('.je-menu');
    if (dialog) show(dialog, null);
  });
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('dialog[open]').forEach(dialog => dialog.close()));
  window.addEventListener('storage', event => { if (event.key === key) { sync(); if (document.querySelector('#je-wishlist')?.open) renderWishlist(); } });
  document.addEventListener('cart:update', sync);
  new MutationObserver(mutations => {
    if (mutations.some(mutation => [...mutation.addedNodes].some(node => node instanceof Element && (node.matches('[data-je-wish]') || node.querySelector('[data-je-wish]'))))) sync();
  }).observe(document.body, { childList: true, subtree: true });
  initialize();
})();
